import { InterceptorClient } from "../../interceptor/interceptorClient";
import { categoryReviewsEndPoint, ratingsEndPoint, testimonialsEndPoint } from "./constant";

/**
 * Fetches category reviews from the search service for category testimonial pages.
 *
 * @async
 * @function
 * @param {object} options - Request options.
 * @param {string} options.categoryId - Category identifier, with or without the `-lp` suffix.
 * @param {number} [options.pageNumber=0] - Page number.
 * @param {number} [options.size=12] - Page size.
 * @returns {Promise<Object>} Category reviews API response.
 */
export const getCategoryReviewsData = async (options) => {
  return await InterceptorClient.getFNTSInstance(process.env.NEXT_PUBLIC_R2_CLIENT_API_GATEWAY).get(
    `${categoryReviewsEndPoint(options)}`,
  );
};

/**
 * Fetches the remaining time for product delivery from the API.
 *
 * This asynchronous function sends a request to the API endpoint returned by `getProductDeliveryTimeLeft()`
 * and retrieves the remaining delivery time for a product.
 *
 * @async
 * @function
 * @returns {Promise<Object>} A promise that resolves to the JSON response from the API, containing the delivery time left.
 * @throws {Error} Will throw an error if the fetch request fails.
 */
export const getTestimonialsData = async (options) => {
  return await InterceptorClient.getFNTSInstance(process.env.NEXT_PUBLIC_R2_CLIENT_API_GATEWAY).get(
    `${testimonialsEndPoint(options)}`,
  );
};

/**
 * Fetches the remaining time for product delivery from the API.
 *
 * This asynchronous function sends a request to the API endpoint returned by `getProductDeliveryTimeLeft()`
 * and retrieves the remaining delivery time for a product.
 *
 * @async
 * @function
 * @returns {Promise<Object>} A promise that resolves to the JSON response from the API, containing the delivery time left.
 * @throws {Error} Will throw an error if the fetch request fails.
 */
export const getRatingsData = async (options) => {
  return await InterceptorClient.getFNTSInstance(process.env.NEXT_PUBLIC_R2_CLIENT_API_GATEWAY).get(
    `${ratingsEndPoint(options)}`,
  );
};
